import { render, staticRenderFns } from "./MenuLateralDireitoCliente.vue?vue&type=template&id=7228e957&scoped=true"
import script from "./MenuLateralDireitoCliente.vue?vue&type=script&lang=js"
export * from "./MenuLateralDireitoCliente.vue?vue&type=script&lang=js"
import style0 from "./MenuLateralDireitoCliente.vue?vue&type=style&index=0&id=7228e957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228e957",
  null
  
)

export default component.exports